import React, { useState } from 'react'
import { Input } from 'antd';
import { Row, Col, Button } from 'antd'
import { withCookies, Cookies } from 'react-cookie';
import { Login } from '../api/api'
import { openNotification } from './utils';
import { useCookies } from 'react-cookie';

const LoginForm = () => {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [setCookie] = useCookies(['name']);

    const handleLogin = async () => {

        const queryData = {email, password}
        const resp = await Login(queryData)
        const { data } = resp
        openNotification(data)
        if(data.result) {
            setCookie('JWTToken', data.JWTToken)
            setCookie('email', email)
        }
        window.location.reload()

    } 

    return <>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={4}>Email: </Col>
                <Col span={20}>
                    <Input value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                </Col>
            </Row>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={4}>Password: </Col>
                <Col span={20}>
                    <Input type="password" value={password} onChange={(e)=>{setPassword(e.target.value)}}/>
                </Col>
            </Row>
            <Row style={{margin: 16}} gutter={20}>
                <Col span={24}>            
                    <Button type='primary' style={{width: '100%'}} onClick={handleLogin}>Login</Button>
                </Col>
            </Row>
        </>
}

export default withCookies(LoginForm)
